export enum CookieList {
  DOCUMENT_ENTRYPOINT = 'document-entrypoint'
}
